import {
  fromMinutesToTime,
  formatMinutesToMMSS,
  formatSecondsToHHMM,
} from '../utils/date';

const formatNumberValue = (value, defaultValue) =>
  value ? value : defaultValue;

const formatComplexValue = (value, subValue, needPercentage = false) => {
  const formatValue = formatNumberValue(value, 0);
  const formatSubValue = formatNumberValue(subValue, 0);
  return `${formatValue} (${formatSubValue}${needPercentage ? '%' : ''})`;
};

export const subHeaderConfig = [
  {
    key: 'totalRoutes',
    subKey: '',
    label: 'Routes:',
    formatValue: (value) => formatNumberValue(value, 0),
  },
  {
    key: 'stops',
    subKey: 'totalStops',
    label: 'Stops:',
    formatValue: (value, subValue) => formatComplexValue(value, subValue),
  },
  {
    key: 'parcels',
    subKey: 'totalParcels',
    label: 'Parcels:',
    formatValue: (value, subValue) => formatComplexValue(value, subValue),
  },
  {
    key: 'collections',
    subKey: 'totalCollections',
    label: 'Collections:',
    formatValue: (value, subValue) => formatComplexValue(value, subValue),
  },
  {
    key: 'totalRouteExceptions',
    subKey: 'totalExceptions',
    label: 'Exceptions:',
    formatValue: (value, subValue) => formatComplexValue(value, subValue),
  },
  {
    key: 'totalDepartedRoutes',
    subKey: 'departedRoutePercentage',
    label: 'Departed:',
    formatValue: (value, subValue) => formatComplexValue(value, subValue, true),
  },
  {
    key: 'stopsPerRoute',
    subKey: '',
    label: 'SPR:',
    formatValue: (value) => formatNumberValue(value, 0),
  },
  {
    key: 'totalParcelsOfd',
    subKey: '',
    label: 'OFD',
    formatValue: (value) => formatNumberValue(value, 0),
  },
  {
    key: 'averageScanTime',
    subKey: '',
    label: 'Scan Time',
    formatValue: (value) => formatMinutesToMMSS(value),
  },
  {
    key: 'averageDutyTime',
    subKey: '',
    label: 'Duty',
    formatValue: (value) => fromMinutesToTime(formatNumberValue(value, 0)),
  },
  {
    key: 'averageOpportunityTime',
    subKey: '',
    label: 'OT',
    formatValue: (value) => formatSecondsToHHMM(formatNumberValue(value, 0)),
  },
];

export const subHeaderIconsConfig = [
  {
    key: 'totalOpenRequests',
    subKey: '',
    label: 'Request',
    formatValue: (value) => formatNumberValue(value, 0),
  },
  {
    key: 'totalRoutesExceededScanTime',
    subKey: '',
    label: 'Warning',
    formatValue: (value) => formatNumberValue(value, 0),
  },
];
